var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$isReadOnly())?_c('div',[_c('transition',{attrs:{"name":"fade-up-down"}},[_c('product-search-selection',{attrs:{"context":_vm.context,"excluded-product-ids":_vm.getExcludedProducts,"quantity-to-add":_vm.quantityToAdd,"show-quantity-selector":true},on:{"added":function($event){return _vm.$emit('added')}}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }